import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const THANKS_TITLE = "Message envoyé — Données & Droit";
const THANKS_DESCRIPTION =
    "Confirmation de bonne réception de votre message envoyé via le formulaire de contact de donnees-et-droit.fr.";

export function ThanksPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main data-testid="thanks-page">
            <SEO
                path="/merci"
                title={THANKS_TITLE}
                description={THANKS_DESCRIPTION}
                robots="noindex, follow"
            />
            <Header />
            <section
                className="border-b border-slate-200 bg-white"
                data-testid="thanks-section"
            >
                <div className="mx-auto max-w-3xl px-6 md:px-12 lg:px-16 pt-24 md:pt-32 pb-20 md:pb-28">
                    <p className="text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                        Confirmation
                    </p>
                    <h1
                        className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                        data-testid="thanks-title"
                    >
                        Votre message a bien été envoyé.
                    </h1>
                    <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed max-w-2xl">
                        Merci pour votre prise de contact. Une réponse
                        personnelle vous parviendra sous quelques jours
                        ouvrés à l'adresse que vous avez indiquée. Aucune
                        information n'est transmise à des tiers.
                    </p>
                    <div className="mt-10">
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 text-sm font-medium text-[#0B132B] border-b border-[#0B132B] pb-0.5 hover:gap-3 transition-all"
                            data-testid="thanks-back-home"
                        >
                            ← Retour à l'accueil
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    );
}
